import {  useTranslation } from 'react-i18next';

import {MwInputText,MwSelector} from '../../ui';
import { useEffect, useState } from 'react';
import { LuBanknote } from 'react-icons/lu';

const InvFormHeader = ({
    invNo,
    setInvNo,
    invRef,
    invDate,
    invDateDue,
    invCurrency,
    customers,
    onClickNewCustomer,
    salesmans,
    onClickNewSalesman,
    customerSelected,
    setCustomerSelected,
    salesmanSelected,
    setSalesmanSelected,
    formErrors,
    initalCustomerName,
    initalSalesmanName,
    taxesList,
    setTaxesList,
    currentCompanyId,
    currentTenantId,
    currencies,
    setCurrencies,
    setSelectedCurrency,
    selectedCurrency,
    currencySymbol
    }) => {
        const [t,i18next] = useTranslation('global')
        const lang= i18next.dir() === 'rtl' ? 'ar' : 'en';
        const formatCurrenciesForSelector = () => {
            if (!currencies || currencies.length === 0) {
                return [];
            }
            
            return currencies.map(currency => ({
                label: ` ${lang === 'ar' ? currency.name_ar || currency.name_en : currency.name_en || currency.name_ar}`,
                value: currency.id,
                ...currency
            }));
        };

   
        const [showCurrencySelector, setShowCurrencySelector] = useState(false);
        

        const date = new Date();
        const today = date.toLocaleDateString('en-CA'); // Get current date in the format 'YYYY-MM-DD'
        const todayAndTime = date.toLocaleDateString('en-CA')+' '+date.toLocaleTimeString('it-IT'); // Get current date in the format 'YYYY-MM-DD'
useEffect(()=>{
    console.log("salesmanSelected:",salesmanSelected);
    
},[salesmanSelected])
    return (
            <div className="flex flex-col gap-2 md:flex-row justify-between  items-center ">
                <div className="flex w-full gap-2 md:w-fit " >
                    <div className="flex-1 md:w-24   ">
                        <MwInputText 
                            label={t("quotes.quoteNumber")}
                            id='inv_no' 
                            value={invNo} 
                            disabled={true} 
                            onChange={(e)=>setInvNo(e.target.value)} />
                    </div>
                    <div className="flex-1 md:w-20">
                        <MwInputText 
                            label={t('invoice.invoiceRef')}
                            inputRef={invRef}
                            id='inv_ref' 
                            defaultValue={invRef.current?.value}
                            />
                    </div>
                </div>
                    <div className="flex w-full gap-2 md:w-fit " >
                    <div className="flex-1 md:w-38 ">
                        <MwInputText 
                            label={t('invoice.invoiceDate')}
                             inputType='datetime-local'
                            inputRef={invDate} 
                            id='inv_date'
                            defaultValue={invDate.current}
                            invalid = {!!formErrors?.invDate}
                            disabled = {false}
                            // invalidMsg={formErrors?.invDate}
                            />
                    </div>
                    <div className="flex-1 md:w-28">
                        <MwInputText 
                            label={t('invoice.invoiceDateDue')}
                            inputType='date'
                            inputRef={invDateDue} 
                            id='inv_date_due'
                            defaultValue={invDateDue.current}
                            invalid = {!!formErrors?.invDateDue}
                            />
                    </div>
                </div>
                <div className="relative flex-1  flex gap-2 w-full ">
                    <div className="flex-1 flex  flex-col ">
                        <MwSelector 
                            label={t('invoice.selectCustomer')}
                            initalValue={initalCustomerName}
                            _data={customers} 
                            dataType='customer' 
                            onClickNew = {onClickNewCustomer}
                            selectedItem = {customerSelected}
                            setSelectedItem = {setCustomerSelected}
                            />
                    </div>
                    <div className="flex-1 flex flex-col ">
                        <MwSelector
                        label={`${t('invoice.selectSalesman')}...`}
                        initalValue={initalSalesmanName}
                        _data={salesmans} 
                        dataType='salesman' 
                        onClickNew={onClickNewSalesman}
                        selectedItem = {salesmanSelected}
                        setSelectedItem = {setSalesmanSelected}
                        />
                    </div>

                    <div className="w-36 flex flex-col ">

{ !showCurrencySelector &&  selectedCurrency === null ?  (
                       <button 
                         onClick={() => setShowCurrencySelector(true)}
                         className="w-full h-full  mt-6 max-h-[30px] flex items-center justify-center gap-2 p-2 border border-gray-300 rounded-md hover:bg-blue-50 text-blue-600 text-xs transition-all duration-300"
                       >
                         <svg className="w-4 h-4 animate-bounce" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                         <LuBanknote/>
                         </svg>
                         <span className='font-bold '>{currencySymbol}</span>
                       </button>
                     ):
<MwSelector
label={lang === 'ar' ? "العملة" : "Currency"}
_data={formatCurrenciesForSelector()}
dataType="labelValue"
setSelectedItem={setSelectedCurrency}
selectedItem={selectedCurrency}
defaultValue={selectedCurrency?.label || (lang === 'ar' ? "اختر العملة" : "Select Currency")}
value={selectedCurrency}
withSearch={false}
withLabel={false}
withAddNew={false}
/> }
</div>
                </div>
            </div>
        
    )
}

export default InvFormHeader